export default __webpack_public_path__ + "static/media/buddy-notepad.1ed5594e.png";